import React, { useEffect, useState } from "react";

interface TypewriterProps {
  texto: string;
  tempoEscrita?: number; // Tempo entre os caracteres em milissegundos
  tempoDuracao?: number; // Tempo de espera após o texto ser escrito, antes de limpar
  textSize: any;
}

const Typewriter: React.FC<TypewriterProps> = ({
  texto,
  tempoEscrita = 100,
  tempoDuracao = 2000,
  textSize,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    const handleTypewriter = () => {
      if (!isDeleting) {
        if (displayedText.length < texto.length) {
          setDisplayedText((prev) => prev + texto[prev.length]);
        } else {
          timeout = setTimeout(() => setIsDeleting(true), tempoDuracao);
        }
      } else {
        if (displayedText.length > 0) {
          setDisplayedText((prev) => prev.slice(0, -1));
        } else {
          setIsDeleting(false);
        }
      }
    };

    timeout = setTimeout(handleTypewriter, tempoEscrita);

    return () => clearTimeout(timeout);
  }, [displayedText, isDeleting, texto, tempoEscrita, tempoDuracao]);

  return (
    <div style={{ fontFamily: "monospace", fontSize: textSize, textTransform: "uppercase", color: "white" }}>
      {displayedText}
      <span className="cursor" style={{ opacity: isDeleting ? 0 : 1 }}>
        |
      </span>
    </div>
  );
};

export default Typewriter;
